module.exports = __webpack_public_path__ + "img/title_chat.17c3050d.png";